import { ID } from "../core/id";

export enum JobStatus {
  DO = "do", // Создан
  NO_HOLD = "no_hold", // Не оплачен
  WORK = "work", // В работе
  WAIT_CHECK = "wait_cheack", // На проверке (шаг 1-й)
  NO_FIND_REVIEW = "nofind_review", // Отзыв не найден
  WAIT_CHECK2 = "wait_cheack2", // На проверке (шаг 2-й)
  WAIT_PAY = "wait_pay", // Скоро оплатим
  NO_WORK = "no_work", // Не выполнен
  DELETE = "delete", // Удалён
  CLOSE = "close", // Выполнен
}

export type JobType = "sub" | "review";
export enum EJobType {
  SUB = "sub",
  REVIEW = "review",
}
export interface JobBase {
  // 🔑 Основные поля
  id: ID;
  view_id: string;
  order_id: ID;
  place_id: ID;
  url: string;
  status: JobStatus;
  type: JobType;

  // 👥 Связи с пользователями
  executor_id?: ID;
  current_work_id?: ID;
  description: string;

  // 💰 Финансовые поля
  amount_executor: number;
  amount: number;

  // 📝 Контент
  properties: any;
  format: any;

  // ⏰ Временные метки
  date_public: number;
  date_modified: number;
  date_published: number;
  file_ids?: ID[];
}

export interface JobReview extends JobBase {
  properties: {
    text?: string;
    is_ai_text: boolean;
    keywords?: string[];
  };
}
export interface JobSub extends JobBase {
  properties: {
    count_start: number;
    click_start: boolean;
    is_note_not_find: boolean;
    percent?: number;
    hash?: string;
  };
}

export interface JobTemplate {
  text?: string;
  file_ids?: ID[];
  date_public: number;
}
export type JobView = JobReview | JobSub;

export const JOB_STATUS_NAMES = {
  do: "Создан",
  no_hold: "Заморожен",
  work: "Ожидает выполнения",
  wait_cheack: "Проверяем",
  wait_cheack2: "Проверяем",
  nofind_review: "Проблема с заданием",
  wait_pay: "Готов к оплате",
  no_work: "Не выполнен",
  delete: "Отменено",
  close: "Выполнено",
  cancel: "Отменено",
} as const;

export const JOB_STATUS_COLORS = {
  do: "info",
  no_hold: "warning",
  work: "success",
  wait_cheack: "warning",
  wait_cheack2: "warning",
  nofind_review: "warning",
  wait_pay: "info",
  no_work: "error",
  delete: "info",
  close: "success",
  cancel: "error",
} as const;
export const JOB_STATUS_CLIENT_NAMES = {
  do: "Создан",
  no_hold: "Заморожен",
  work: "Выполняется",
  wait_cheack: "Проверяем",
  wait_cheack2: "Проверяем",
  nofind_review: "Проблема с заданием",
  wait_pay: "Проверен",
  no_work: "Не оплачено",
  delete: "Отменено",
  close: "Выполнено",
  cancel: "Отменено",
} as const;
export const JOB_FILES_URL_ICON = "/media/content/jobs/";
